import { api } from "../../api";

// Every dataset of a project, as the caller sees it: its studies (GET /projects/{id}/studies),
// then each study's datasets (GET /studies/{id}/datasets), flattened in study order. Each dataset
// gets `study_name`. Every project member sees them all, so no access rule of its own is needed.
// Used by provenance/AnalysisForm (inputs and results) and columns/DatasetPicker.
export async function loadProjectDatasets(projectId) {
  const studies = await api.get(`/projects/${projectId}/studies`);
  const lists = await Promise.all((studies || []).map(s =>
    api.get(`/studies/${s.id}/datasets`).then(ds => (ds || []).map(d => ({ ...d, study_name: s.name })))));
  return lists.flat();
}
